/**
 * The build's git SHA, for correlating a tester's report with the code they ran.
 *
 * Injected as a build arg, NOT read from the repository. `.git` is deliberately never
 * mounted into a container or added to an image: the served image is `nginx:alpine` with
 * only `/app/build` copied in, and `.git` sits outside the `./web` build context
 * entirely. Keeping it that way means the only thing that ships is the seven characters
 * below. The alternative — a backend endpoint reporting its own SHA — needs `.git` mounted
 * into a running container, which is the exposure this avoids.
 *
 * `docker-compose.yml` passes `REACT_APP_GIT_SHA: ${GIT_SHA:-unknown}` and CRA bakes it in
 * at `yarn build`. Two fallbacks, and the difference between them is the diagnosis:
 *
 *   'dev'      — no build arg at all, i.e. `yarn start`. Expected locally.
 *   'unknown'  — an image built without GIT_SHA set. On production that means someone ran
 *                `docker compose build web` without the env var; see docs/DEPLOYMENT.md.
 *
 * This names the **frontend bundle**. `backend` is bind-mounted and deploys by `git pull`
 * + restart with no rebuild, so after a backend-only deploy this string still points at
 * the last web build. That is the honest answer to "which UI is this tester on?" — if the
 * backend's own SHA is ever needed, that is a separate endpoint.
 */
export const GIT_SHA = process.env.REACT_APP_GIT_SHA || 'dev';

/** Rendered form, e.g. `ver a1b2c3d`. */
export const VERSION_LABEL = `ver ${GIT_SHA}`;
